// 碳积分相关路由
export default {
  routes: [
    {
      // 介绍前置动画
      path: '/carbonScore/introduce',
      name: 'carbonScoreIntroduce',
      meta: {
        title: '碳积分介绍页',
        desc: '碳积分介绍页'
      },
      component: () =>
        import(/* webpackChunkName: "carbonScoreIntroduce" */ '../views/carbonScore/introduce.vue')
    },
    {
      // 介绍前置动画新
      path: '/carbonScore/introduceNew',
      name: 'carbonScoreIntroduceNew',
      meta: {
        desc: '碳积分介绍页'
      },
      component: () =>
        import(
          /* webpackChunkName: "carbonScoreIntroduceNew" */ '../views/carbonScore/introduceNew.vue'
        )
    },
    {
      // 账户中心页
      path: '/carbonScore/home',
      name: 'carbonScoreHome',
      meta: {
        title: '转转星球(试运行)',
        pageId: 'W8262'
      },
      component: () =>
        import(/* webpackChunkName: "carbonScoreHome" */ '../views/carbonScore/home.vue')
    },
    {
      // 碳积分明细页
      path: '/carbonScore/recordsList',
      name: 'carbonScoreRecordsList',
      meta: {
        title: '碳积分明细',
        pageId: 'M9294'
      },
      component: () =>
        import(
          /* webpackChunkName: "carbonScoreRecordsList" */ '../views/carbonScore/recordsList.vue'
        )
    },
    {
      // 兑换详情
      path: '/carbonScore/changeDetail',
      name: 'carbonScoreChangeDetail',
      meta: {
        title: '兑换详情',
        pageId: 'F4657'
      },
      useUrlParams: ['infoid'],
      component: () =>
        import(
          /* webpackChunkName: "carbonScoreChangeDetail" */ '../views/carbonScore/changeDetail.vue'
        )
    },
    {
      // 碳积分独立页面-现金天天领
      path: '/carbonScore-standalone',
      name: 'carbonScoreStandalone',
      meta: {
        title: '现金天天领'
      },
      component: () => import('../views/carbonScoreStandalone/index.vue')
    },
    {
      // 碳积分兑换码页面
      path: '/redemption-code',
      name: 'redemptionCode',
      meta: {
        title: '兑换码',
        auth: true,
        pageId: 'M1066'
      },
      component: () => import('../views/carbonScoreStandalone/redemptionCode.vue')
    },
    {
      // 碳积分核销详情页
      path: '/verification-detail',
      name: 'verificationDetail',
      meta: {
        title: '领取礼品',
        auth: true,
        pageId: 'K7076'
      },
      component: () => import('../views/carbonScoreStandalone/verificationDetail.vue')
    }
  ]
}
